module.exports = __webpack_public_path__ + "assets/media/clearIcon.915d2f49.svg";